/**
 * Copyright (c) 2020-2021 Perficient, Inc.
 * Unauthorized copying or distribution of this file prohibited without the express permission of Perficient.
 */

import React, { useState, useCallback } from "react";
import { List, ListItem, ListItemText, ListSubheader, Button, TextField } from "@material-ui/core";
import { ConfirmDialog } from "../../../components/ConfirmDialog/ConfirmDialog";
import { v2, errorToObject } from "@prftesp/cle-logger";

export const DispositionList = ({
	dispositions,
	addDispositionHandler,
	selectDispositionHandler,
	selectedDispositionId,
	formEdited,
}) => {
	const [searchTerm, setSearchTerm] = useState("");
	const [editConfirmOpen, setEditConfirmOpen] = React.useState(false);
	const [disposition, setDisposition] = useState(null);

	const handleSearchChange = useCallback((e) => {
		setSearchTerm(e.target.value);
	}, []);

	const searchMatches =
		dispositions?.filter((x) => x.dispositionName.toLowerCase().includes(searchTerm.toLowerCase())) || [];

	return (
		<div>
			<List
				component="nav"
				subheader={
					<ListSubheader disableSticky component="div">
						<div style={{ marginBottom: 8 }}>
							<TextField
								style={{ width: "100%" }}
								size="small"
								label="Search dispositions"
								value={searchTerm}
								onChange={handleSearchChange}
								inputProps={{
									"data-test-id": "disposition-search-input",
								}}
							/>
						</div>
						<div className="d-flex flex-row justify-content-between align-items-center flex-wrap">
							<span>Dispositions</span>

							<Button
								variant="outlined"
								className="mb-2 mb-md-0"
								size="small"
								disabled={!!selectedDispositionId && formEdited}
								onClick={addDispositionHandler}
								data-test-id="disposition-add-btn"
							>
								Add
							</Button>
						</div>
					</ListSubheader>
				}
			>
				{dispositions?.length && searchMatches.length > 0 ? (
					dispositions.map((x) => {
						const searchMatch = searchMatches.find((s) => s.dispositionId === x.dispositionId);
						return (
							<ListItem
								button
								selected={x.dispositionId === selectedDispositionId}
								onClick={() => {
									setDisposition(x);
									formEdited ? setEditConfirmOpen(true) : selectDispositionHandler(x);
								}}
								key={x.dispositionId}
								style={{ display: searchMatch ? "flex" : "none", opacity: x.isEnabled ? 1 : 0.75 }}
							>
								<ListItemText style={{ overflowWrap: "break-word" }} primary={x.dispositionName} />
							</ListItem>
						);
					})
				) : (
					<ListItem>
						<span className="text-muted font-italic">
							{!searchTerm
								? "No dispositions yet, click the 'Add' button to create a new one."
								: "No dispositions found."}
						</span>
					</ListItem>
				)}
			</List>
			<ConfirmDialog
				title={"Switch Disposition?"}
				message={"You have unsaved changes that will be discarded if you proceed. Are you sure?"}
				confirmOpen={editConfirmOpen}
				onClose={async (confirmed) => {
					try {
						if (confirmed) {
							selectDispositionHandler(disposition);
						}
						setEditConfirmOpen(false);
					} catch (error) {
						v2.error(`Error while cancelling disposition.`, {
							additionalData: { error: errorToObject(error) },
						});
					}
				}}
			/>
		</div>
	);
};
